import styled from 'styled-components';

export const UiHomeInvitePage = styled.div`
	display: block;
`;